import React from 'react';
import { useTranslation } from 'react-i18next';

const Card = ({ first_name, last_name, gender, email, tent_name = 'N/A' }) => {
    const { t } = useTranslation();

    return (
        <div className="relative rounded-3xl overflow-hidden shadow-lg border border-gray-200">
            {/* Gender Badge with Background Color */}
            <span
                className={`absolute top-0 left-0 w-full h-2 ${
                    gender === 'Male' ? 'bg-blue-400' : 'bg-yellow-400'
                } z-10`}
            ></span>

            <div className="bg-white rounded-tl-[1.75rem] py-4 px-5 break-inside-avoid relative z-20">
                {/* Name and Gender */}
                <div className="flex justify-between items-center py-4 border-b font-medium">
                    <span className="flex gap-1 text-secondary">
                        <h1 className="text-tertiary">{first_name}</h1>
                        <h1 className="text-tertiary">{last_name}</h1>
                    </span>
                    <div className="flex items-center gap-2">
                        {gender.toLowerCase() === 'male' ? (
                            <>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 22"
                                    width="1em"
                                    height="1em"
                                    className="text-black"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M14.145 16.629a24 24 0 0 1-.052-2.525l-.001.037a4.85 4.85 0 0 0 1.333-2.868l.002-.021c.339-.028.874-.358 1.03-1.666a1.22 1.22 0 0 0-.455-1.218l-.003-.002c.552-1.66 1.698-6.796-2.121-7.326C13.485.35 12.479 0 11.171 0c-5.233.096-5.864 3.951-4.72 8.366a1.22 1.22 0 0 0-.455 1.229l-.001-.008c.16 1.306.691 1.638 1.03 1.666a4.86 4.86 0 0 0 1.374 2.888a25 25 0 0 1-.058 2.569l.005-.081C7.308 19.413.32 18.631 0 24h22.458c-.322-5.369-7.278-4.587-8.314-7.371z"
                                    ></path>
                                </svg>
                                <span className="text-black">
                                    {t('tent-management-page.Male')}
                                </span>
                            </>
                        ) : (
                            <>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 100 100"
                                    width="1em"
                                    height="1em"
                                    className="text-black"
                                >
                                    <path
                                        fill="currentColor"
                                        d="m80.161 60.442l-15.66-7.47l-6.622-3.159c.166-.105.324-.224.487-.335h8.695a2.44 2.44 0 0 0 2.438-2.438v-6.415h-.022c-.266-8.94-3.371-16.805-8.034-21.737c-2.459-2.773-5.646-4.657-9.211-5.22q-.238-.04-.478-.071q-.275-.036-.553-.061a14 14 0 0 0-1.202-.059h-.002c-.398 0-.791.023-1.183.057q-.282.026-.56.062q-.234.03-.465.068c-3.536.553-6.701 2.408-9.153 5.141c-4.708 4.927-7.847 12.829-8.115 21.821H30.5v6.415a2.44 2.44 0 0 0 2.438 2.438h8.719c.238.162.475.327.721.475l-6.342 2.953l-16.168 7.53c-1.405.658-2.327 2.242-2.327 4.011v17.765c0 2.381 1.659 4.311 3.708 4.311h57.504c2.049 0 3.708-1.93 3.708-4.311V64.446c-.001-1.763-.909-3.332-2.3-4.004"
                                    ></path>
                                </svg>
                                <span className="text-black">
                                    {t('tent-management-page.Female')}
                                </span>
                            </>
                        )}
                    </div>
                </div>

                {/* Email */}
                <div className="py-3">
                    <div className="flex justify-between items-center mt-2">
                        <h1 className="text-gray-400 text-sm font-medium">
                            {t('participants-page.Email')}
                        </h1>
                        <p className="text-secondary text-sm font-medium">
                            {email}
                        </p>
                    </div>
                </div>

                {/* Tent Name */}
                <div className="py-3">
                    <div className="flex justify-between items-center mt-2">
                        <h1 className="text-gray-400 text-sm font-medium">
                            {t('participants-page.Tent Name')}
                        </h1>
                        <p className="text-secondary text-sm font-medium">
                            {tent_name}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Card;
